<template>
  <section>
    <v-text-field
        v-model="search"
        :label="label ? label : ''"
        :loading="loading"
        clearable
        :error="error"
        :error-messages="errorMessages"
        ref="product">
      </v-text-field>
    <v-dialog v-if="dialog" v-model="dialog" fullscreen>
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            ref="productSearch"
          ></v-text-field>
          <v-spacer/>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            rows-per-page-text="Rezultate pe pagină"
            disable-initial-sort
            item-key="id"
            v-model="selected"
            :hide-actions="!hasPagination"
            no-data-text="Nu există date"
            ref="table"
          >
            <template slot="items" slot-scope="props">
              <tr :active="props.selected"  @click="props.selected = true">
                <td class="line-height-2" v-for="(header, index) in headers" :key="index" v-html="displayRowData(props, header)"></td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="dialog = false">Anulează</v-btn>
          <v-btn color="primary"
                  @click.native="onProductSelect()"
                  :loading="processing"
                  :disabled="processing || items.length === 0">
              Selectează
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
  export default {
    props: ['value', 'label', 'item-value', 'apiEndpoint', 'error', 'error-messages'],

    data: () => ({
      dialog: false,
      product: '',
      search: '',
      loading: false,
      pagination: {},
      rowsPerPageItems: [5, 10, 25, 50, { 'text': 'Tot', 'value': -1 }],
      totalItems: 0,
      timeoutId: null,
      processing: false,
      selected: [],
      firstLoad: false
    }),

    watch: {
      pagination: {
        handler(newValue, oldValue) {
          if (newValue.page === oldValue.page && this.search && newValue.rowsPerPage === oldValue.rowsPerPage) {
            return;
          }
          this.loadItems();
        },
        deep: true
      },

      search(value) {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
          if (this.firstLoad) {
            this.firstLoad = false;
            if (!value) {
              this.$emit('input', null);
            }
            return;
          }

          if (this.dialog === false && value) {
            this.dialog = true;
          }

          if (!this.dialog && !value) {
            this.$emit('input', null);
            return;
          }
          if (this.pagination.page === 1) {
            this.loadItems();
          } else {
            this.pagination.page = 1;
            this.loadItems();
          }
        }, 500);
      },

      selected(value) {
        if (value.length > 1) {
          value.splice(0, 1);
        }
      },

      dialog(value) {
        this.$store.commit(`${this.apiEndpoint}/${this.apiEndpoint.toUpperCase()}`, []);
        if (value) {
          this.$nextTick(() => {
            this.$refs.productSearch.focus();
          });
        }
      },

      value(value) {
        if (value === null) {
          this.search = '';
        }
      }
    },

    computed: {
      items() {
        return this.apiEndpoint === 'stock'
          ? this.$store.state[this.apiEndpoint].data.filter(f => f.qty > 0)
          : this.$store.state[this.apiEndpoint].data;
      },

      hasPagination() {
        return this.totalItems > 5;
      },

      headers() {
        let headers = [
          {
            text: 'Cod',
            align: 'left',
            sortable: false,
            value: `${this.apiEndpoint === 'stock' ? 'product_id' : 'cod'}`,
            nestedValue: this.apiEndpoint === 'stock' ? 'product.cod' : null
          },
          {
            text: 'Denumire',
            align: 'left',
            sortable: false,
            value: `${this.apiEndpoint === 'stock' ? 'product_id' : 'name'}`,
            nestedValue: this.apiEndpoint === 'stock' ? 'product.name' : null
          },
          {
            text: `${this.apiEndpoint === 'stock' ? 'Cantitate' : 'Cod furnizor'}`,
            align: 'left',
            sortable: false,
            value: this.apiEndpoint === 'stock' ? 'qty' : 'cod_furnizor',
            format: (item) => {
              if (this.apiEndpoint === 'stock') {
                return Math.round(Number(item.qty) * 100) / 100;
              }
              return item.cod_furnizor;
            }
          }
        ];

        if (this.apiEndpoint === 'stock') {
          headers.push({
            text: `Stare`,
            align: 'left',
            sortable: false,
            value: `status`,
            format: (item) => {
              return this.$store.getters['stock/status'](item.status).name;
            }
          });
        }

        return headers;
      }
    },

    methods: {
      loadItems(id) {
        this.loading = true;
        if (id) {
          this.$store.dispatch(`${this.apiEndpoint}/LOAD_ONE`, id)
            .then((result) => {
              this.loading = false;
              this.search = result ? result.data.name ? result.data.name : result.data.product.name : '';
            });
        } else {
          let filter = {
            search: this.search,
            ...this.pagination
          };

          if (this.apiEndpoint === 'stock') {
            filter = { ...filter, employee_id: this.$store.state.user.id };
          }
          this.$store.dispatch(`${this.apiEndpoint}/LOAD`,
            { filter })
            .then((result) => {
              this.totalItems = result.meta.total;
              this.selected = this.items.length ? this.items.slice(0, 1) : [];
              this.loading = false;
            });
        }
      },

      onProductSelect() {
        const selected = this.selected.length ? this.selected[0] : null;
        if (this.itemValue) {
          this.$emit('input', selected[this.itemValue]);
        } else {
          this.$emit('input', selected);
        }
        this.search = selected ? this.apiEndpoint === 'stock' ? selected.product.name : selected.name : this.search;
        this.firstLoad = true;
        this.dialog = false;
      },

      displayRowData(props, header) {
        if (props.item[header.value] || props.item[header.value] === 0) {
          if (header.nestedValue) {
            let nestedValues = header.nestedValue.split('.');
            let rowData = { ...props.item };
            nestedValues.forEach(prop => {
              rowData = rowData[prop];
            });
            return rowData;
          } else if (header.format) {
            return header.format(props.item);
          } else {
            return props.item[header.value];
          }
        }
        return '';
      }
    },

    created() {
      this.$nextTick(() => {
        this.$refs.product.focus();
      });
      if (this.value) {
        this.loadItems(this.value);
        this.firstLoad = true;
      }
      this.pagination.rowsPerPage = 5;
    }
  };
</script>

<style>
  .v-table tbody tr[active] {
    background: #90CAF9 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductSearch.vue